import request from 'src/utils/request';

export const getSlideVerificatePicture = () => request.get('/api/car/admin/captcha/slider');
